<template>
    <DsModal
        show-close
        is-open
        title="Rename template"
        @close="$emit('close')"
    >
        <RenameTemplateForm
            :template="template"
            @saved="$emit('saved', $event)"
        />
    </DsModal>
</template>

<script>
import RenameTemplateForm from './RenameTemplateForm';

export default {
    components: {
        RenameTemplateForm,
    },

    props: {
        template: Object,
    },
};
</script>
